import React, { useState } from 'react';
import { func, string } from 'prop-types';
import { Box, Button, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import Modal from '../Modal';
import InputField from '../InputField';
import staticText from '../../localization/Components/verifyPasswordModal';

const VerifyPasswordModal = ({
  verifyPasswordToChangeAccountInfoRequest,
  resetErrors,
  closeModal,
  verifyPasswordError,
}) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleVerify = () => {
    verifyPasswordToChangeAccountInfoRequest({ oldPassword: password });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleVerify(event);
    }
  };

  const handleCancel = () => {
    closeModal();
    resetErrors();
  };

  const togglePasswordVisibility = () => {
    setShowPassword(show => !show);
  };

  const content = (
    <form onSubmit={e => e.preventDefault()}>
      <InputField
        label={staticText.textBody}
        inputType={showPassword ? 'text' : 'password'}
        inputName="password"
        maxlength={64}
        inputValues={password}
        inputPlaceholder="Password"
        handleChange={e => setPassword(e.target.value)}
        errorMessage={verifyPasswordError}
        InputProps={{
          onKeyDown: handleKeyDown,
        }}
        fullWidth
        autoFocus
        required
        endAdornment={
          <IconButton onClick={togglePasswordVisibility} sx={{ border: 'none' }}>
            {showPassword ? (
              <Visibility />
            ) : (
              <VisibilityOff />
            )}
          </IconButton>
        }
      />
      <Box display="flex" justifyContent="flex-end" gap={1} marginTop={2}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          color="secondary"
        >{staticText.cancel}
        </Button>
        <Button
          variant="outlined"
          onClick={handleVerify}
          disabled={!password}
        >{staticText.verify}
        </Button>
      </Box>
    </form>
  );

  return (
    <Modal
      title={staticText.modalTitle}
      content={content}
      toggleModal={() => {
        closeModal();
        resetErrors();
      }}
    />
  );
};

export default VerifyPasswordModal;

VerifyPasswordModal.propTypes = {
  verifyPasswordToChangeAccountInfoRequest: func.isRequired,
  resetErrors: func.isRequired,
  closeModal: func.isRequired,
  verifyPasswordError: string,
};

VerifyPasswordModal.defaultProps = {
  verifyPasswordError: '',
};
